import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  onRefund() {
    setTimeout(() => location.reload(), 1000);
  }
}
